import React, { useEffect } from "react";
import { trackEvent } from "./../../../utils/analytics";

const useYoutubeTracker = (iframeId, trackingFunction) => {
  const player = React.useRef();

  const trackVideoEvents = () => {
    window.onYouTubeIframeAPIReady = () => {
      player.current = new window.YT.Player(iframeId, {
        events: { onStateChange: trackingFunction || defaultTracking }
      });
    };
    return <></>;
  };

  const defaultTracking = event => {
    switch (event.data) {
      case 0:
        trackEvent("Video operacional finalizado");
        break;
      case 1:
        trackEvent("Video operacional iniciado");
        break;
      case 2:
        trackEvent("Video operacional pausado");
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.youtube.com/iframe_api";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return { trackVideoEvents };
};

export default useYoutubeTracker;
